import { createAsyncThunk } from "@reduxjs/toolkit";
import { organizationAPI } from "libs/apiClient/Organization";
import { OrganizationObjectResponse } from "libs/apiClient/data-contracts";

export const getObjectsRegister = createAsyncThunk(
	"objectsRegisterSlice/getObjectsRegister",
	async (
		{ id, part, quantity, setLoad }: { id: number; part: number; quantity: number; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await organizationAPI
				.objectsDetail(id, {
					part,
					count: quantity,
				})
				.then((r) => r.data);
			// const response = (await $api<any[]>(`/organization/${id}/objects?part=${part}&count=${quantity}`)).data;
			if (setLoad) setLoad();
			return { response, quantity };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getSearchedData = createAsyncThunk(
	"objectsRegisterSlice/getSearchedData",
	async (
		{
			id,
			searchedPart,
			quantity,
			searchValue,
			setLoad,
		}: { id: number; searchedPart: number; quantity: number; searchValue: string; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await organizationAPI
				.objectsDetail(id, {
					part: searchedPart,
					count: quantity,
					query: searchValue,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<any[]>(`/organization/${id}/objects?part=${searchedPart}&count=${quantity}&query=${searchValue}`)
			// ).data;
			if (setLoad) setLoad();
			return { response, quantity };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const createObject = createAsyncThunk(
	"objectsRegisterSlice/createObject",
	async (
		{
			organizationId,
			object,
			document,
			setNewObject,
			setSubmitSuccess,
		}: {
			organizationId: number;
			object: any;
			document: any;
			setNewObject: (obj: any) => void;
			setSubmitSuccess: () => void;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			// const params = new FormData();
			// params.append(
			// 	"params",
			// 	JSON.stringify({
			// 		activityArea: object.activityArea,
			// 		code: object.code,
			// 		creator: object.creator,
			// 		name: object.name,
			// 		ownType: object.ownershipType,
			// 		purpose: object.purpose,
			// 		responsible: object.responsible,
			// 		type: object.objectType,
			// 	}),
			// );
			// if (document) params.append("file", document);
			const newObject = await organizationAPI.objectCreate(organizationId, {
				params: {
					activityArea: object.activityArea,
					code: object.code,
					creator: object.creator,
					name: object.name,
					ownType: object.ownershipType,
					purpose: object.purpose,
					responsible: object.responsible,
					type: object.objectType,
				},
				...(document && { file: document }),
			}).then(r=>r.data);
			// const newObject = (await $api.post<any>(`/organization/${organizationId}/object`, params)).data;
			setNewObject(newObject);
			setSubmitSuccess();
			return newObject;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const editObject = createAsyncThunk(
	"objectsRegisterSlice/editObject",
	async (
		{ object, document, submitSuccessHandler }: { object: any; document: any; submitSuccessHandler: () => void },
		{ rejectWithValue },
	) => {
		try {
			// const params = new FormData();
			// params.append(
			// 	"params",
			// 	JSON.stringify({
			// 		activityArea: object.activityArea,
			// 		code: object.code,
			// 		creator: object.creator,
			// 		name: object.name,
			// 		ownType: object.ownershipType,
			// 		purpose: object.purpose.trim(),
			// 		responsible: object.responsible,
			// 		type: object.objectType,
			// 	}),
			// );
			// if (document) params.append("file", document);
			const newObject = await organizationAPI.objectUpdate(object.id, {
				...(document && { file: document }),
				params: {
					activityArea: object.activityArea,
					code: object.code,
					creator: object.creator,
					name: object.name,
					ownType: object.ownershipType,
					purpose: object.purpose.trim(),
					responsible: object.responsible,
					type: object.objectType,
				},
			}).then(r=>r.data);
			// const newObject = (await $api.put<any>(`/organization/object/${object.id}`, params)).data;
			submitSuccessHandler();
			return newObject;
		} catch (e) {}
	},
);

export const deleteObject = createAsyncThunk(
	"objectsRegisterSlice/deleteObject",
	async (
		{
			objId,
			searchMode,
			orgId,
			part,
			quantity,
			searchValue,
		}: {
			objId: number;
			searchMode: boolean;
			orgId: number;
			part: number | null;
			quantity: number;
			searchValue: string;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			await organizationAPI.objectDelete(objId);
			// await $api.delete<any>(`/organization/object/${objId}`);
			let response: OrganizationObjectResponse[] = [];
			if (part) {
				if (searchMode)
					response = await organizationAPI
						.objectsDetail(orgId, {
							part,
							count: quantity,
							query: searchValue,
						})
						.then((r) => r.data);
				// response = (
				// 	await $api<any[]>(`/organization/${orgId}/objects?part=${part}&count=${quantity}&query=${searchValue}`)
				// ).data;
				else {
					response = await organizationAPI
						.objectsDetail(orgId, {
							part,
							count: quantity,
						})
						.then((r) => r.data);
					// response = (await $api<any[]>(`/organization/${orgId}/objects?part=${part}&count=${quantity}`)).data;
				}
			}
			return { deleteId: objId, newObject: response[response.length - 1] };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getObjectConnection = createAsyncThunk(
	"objectsRegisterSlice/getObjectConnection",
	async (
		{
			organizationId,
			objectId,
			setLoading,
		}: { organizationId: number; objectId: number; setLoading: (value: boolean) => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await organizationAPI.objectProcessesDetail(organizationId, objectId).then(({ data }) => data);
			// const response = (await $api<any[]>(`/organization/${organizationId}/object/${objectId}/processes`)).data;
			setLoading(false);
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const editObjectConnection = createAsyncThunk(
	"objectsRegisterSlice/editObjectConnection",
	async (
		{
			organizationId,
			objectId,
			connection,
			all
		}: { organizationId: number; objectId: number; connection: any[]; all:boolean|null; },
		{ rejectWithValue },
	) => {
		try {
			return await organizationAPI
				.objectProcessCreate(organizationId, objectId, {
					list: all === null ? connection : null,
					all
				})
				.then(({ data }) => data);
			// return (
			// 	await $api.post<any[]>(`/organization/${organizationId}/object/${objectId}/process`, {
			// 		list: connection,
			// 		author: author,
			// 	})
			// ).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const uploadDocument = createAsyncThunk(
	"objectsRegisterSlice/uploadDocument",
	async ({ author, objectId, file }: { author: number; objectId: number; file: any }, { rejectWithValue }) => {
		try {
			// const params = new FormData();
			// params.append("file", file);
			return await organizationAPI.objectDocumentCreate(objectId, { file });
			// return (await $api.post<any>(`/organization/object/${objectId}/document`, params)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const dowloadDocument = createAsyncThunk(
	"objectsRegisterSlice/dowloadDocument",
	async (file: any, { rejectWithValue }) => {
		try {
			return await organizationAPI.objectDocumentDetail(file.id, { format: "blob" }).then((response) => {
				// create file link in browser's memory
				const href = URL.createObjectURL(response.data);

				// create "a" HTML element with href to file & click
				const link = document.createElement("a");
				link.href = href;
				link.setAttribute("download", `${file.name ? file.name : "file"}.${file.type}`); //or any other extension
				document.body.appendChild(link);
				link.click();

				// clean up "a" element & remove ObjectURL
				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			});
			// return $api({
			// 	url: `/organization/object/document/${file.id}`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then((response) => {
			// 	// create file link in browser's memory
			// 	const href = URL.createObjectURL(response.data);
			//
			// 	// create "a" HTML element with href to file & click
			// 	const link = document.createElement("a");
			// 	link.href = href;
			// 	link.setAttribute("download", `${file.name ? file.name : "file"}.${file.type}`); //or any other extension
			// 	document.body.appendChild(link);
			// 	link.click();
			//
			// 	// clean up "a" element & remove ObjectURL
			// 	document.body.removeChild(link);
			// 	URL.revokeObjectURL(href);
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const updateDocument = createAsyncThunk(
	"objectsRegisterSlice/updateDocument",
	async ({ objectId, file }: { objectId: number; file: any }, { rejectWithValue }) => {
		try {
			// const params = new FormData();
			// params.append("file", file);
			return await organizationAPI.objectDocumentCreate(objectId, { file }).then((r) => r.data);
			// return (await $api.post<any>(`/organization/object/${objectId}/document`, params)).data;
			// return (await $api.put<any>(`/organization/object/document/${documentId}?user_id=${author}`, params)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

// export const deleteDocument = createAsyncThunk(
// 	"objectsRegisterSlice/deleteDocument",
// 	async ({ author, documentId }: { author: number; documentId: any }, { rejectWithValue }) => {
// 		try {
// 			return (await $api.delete<any>(`/organization/object/document/${documentId}?user_id=${author}`)).data;
// 		} catch ({ message }) {
// 			return rejectWithValue(message);
// 		}
// 	},
// );
